<ng-container *ngIf="firstLoad">
    <ph-stack gap="snug">
        <ph-hint *ngIf="unitsTotal">Loading units: {{ unitsLoaded }} of {{ unitsTotal }}</ph-hint>
        <ph-skeleton shape="list" rows="3" avatar="false" [attr.label]="pick === 'owners' ? 'Loading owners' : 'Loading units'"></ph-skeleton>
    </ph-stack>
</ng-container>

<ph-unit-picker *ngIf="!firstLoad"
                [pick]="pick"
                [defaultTab]="defaultTab"
                [neverLoggedInFilter]="neverLoggedInFilter"
                [units]="units"
                [owners]="owners"
                [unitTags]="unitTags"
                [ownerTags]="ownerTags"
                [columns]="offeredColumns"
                [visibleColumns]="visibleColumns"
                [extraColumns]="extraColumns"
                [ownerContact]="ownerContact"
                [rowAction]="rowAction || ''"
                [blockedPick]="requireEmail || requirePhone"
                [single]="single"
                [loading]="loadingLabel"
                [navigate]="true"
                [value]="unitIds"
                [ownerValue]="memberIds"
                [coverOwners]="coverOwners"
                [disabled]="locked"
                [canShowDeleted]="canShowDeleted"
                [listHeight]="listHeight"
                [searchPlaceholder]="searchPlaceholder"
                (ph-show-deleted)="onShowDeleted($event.detail.show)"
                (ph-row-action)="onRowAction($event.detail.id)"
                (ph-blocked)="onBlocked($event.detail)"
                (ph-navigate)="onNavigate($event.detail.href)"
                (ph-column-visibility)="onColumnVisibility($event.detail.keys)"
                (ph-change)="onChange($event.detail)"></ph-unit-picker>
